import { Provider } from '@angular/core';
import { CommunicationService } from '../communication';
import { LanguageCollectionService, LanguageService } from 'projects/common/src/app/services/parameters';
import { NotificationHandlerService } from 'projects/common/src/app/services';

/**
 * Provee la contrucción de una instancia del servicio que se encvargará de las
 * comunicaciones remotas y que implementará la interfaz de comunicaión remota
 *
 * IRemoteCommunication
 */
const languageCollectionServiceFactory = (
  communicationService: CommunicationService,
  notificationHandlerService: NotificationHandlerService,
  languageService: LanguageService
) => {
  return new LanguageCollectionService(communicationService, notificationHandlerService, languageService);
};

/**
 * Provider que define el alias para la utilización del servicio que se encargará
 * de la comunicación remota y que implementará el método communicationServiceFactory
 * para la creación
 */
export const languageCollectionServiceProvider: Provider = {
  provide: LanguageCollectionService,
  useFactory: languageCollectionServiceFactory,
  deps: [CommunicationService, NotificationHandlerService, LanguageService]
};
